module.exports = __webpack_public_path__ + "img/paymentsWay.4a35bf37.png";